import React,{useRef} from "react";
import { useTheme } from "../../ThemeContext";
import { useSelector } from "react-redux";
import DescriptionIcon from "@mui/icons-material/Description";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { IoCloseOutline } from "react-icons/io5";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";
import { BtnLoader } from "../../components/common/Loader";

export const LeaveDeatils = ({ onCancel, leave }) => {
  // console.log(leave,"leavedetails")
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { isDarkMode } = useTheme();
  const captureRef = useRef(null);
  const [loading, setLoading] = React.useState(false);


   const copyScreenshot = async () => {
 
    
    if (!captureRef.current) return;
    setLoading(true);
   

    try {
      const canvas = await html2canvas(captureRef.current, {
        backgroundColor: "#ffffff", // fixes black background issue
        scale: 2,
      });

      canvas.toBlob(async (blob) => {
        if (blob) {
          await navigator.clipboard.write([
            new ClipboardItem({ "image/png": blob }),
          ]);

          toast.success("Screenshot copied to clipboard!");
        }
      });
    } catch (error) {
      console.error("Copy failed:", error);
    }finally {
    setLoading(false); 
  }
  };

  // Sample data from the image (replace with dynamic data if needed)
  const leaveData = {
    leaveType: "2 Hrs Permission",
    timePeriod: "04:00 Pm - 06:00 Pm",
    date: "31/07/2025",
    status: "Pending",
    comments: "Personal Reasons",
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3 rounded">
        <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3 rounded w-100">
          {/* Left Title */}
          <div className="d-flex text-rgba-gray align-items-center">
            Leave Details
          </div>

          {/* Right Close Button */}
          <button
            onClick={onCancel}
            className="btn border-0 p-0 m-0 d-flex align-items-center"
            style={{ background: "transparent" }}
          >
            <IoCloseOutline size={22} color="var(--text-color)" />
          </button>
        </div>
      </div>

      <div className="bg-white overflow-auto pb-2 pt-3 px-4 " ref={captureRef}>
        {/* Leave Type */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label d-flex align-items-center">
              <DescriptionIcon className="me-1" fontSize="small" />
              <span>Leave Type</span>
            </label>
            <p className="ms-4">{leave.leave_type}</p>
          </div>
        </div>

        {/* Time Period */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label d-flex align-items-center">
              <AccessTimeIcon className="me-1" fontSize="small" />
              <span>Time Period</span>
            </label>
            <p className="ms-4">{leave.time}</p>
          </div>
        </div>

        {/* Date */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label d-flex align-items-center">
              <DateRangeIcon className="me-1" fontSize="small" />
              <span>Date</span>
            </label>
            <p className="ms-4">{leave.date_of_leave}</p>
          </div>
        </div>

        {/* Status */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label d-flex align-items-center">
              <DriveFileRenameOutlineIcon className="me-1" fontSize="small" />
              <span>Status</span>
            </label>
            <p
              className="ms-4"
              style={{
                color:
                  leave.status === "Requested"
                    ? "#ff7875"
                    : leave.status === "Pending"
                    ? " #69c0ff" // blue for pending
                    : leave.status === "Approved"
                    ? " #95de64"
                    : "#6B7280", // fallback gray
              }}
            >
              {leave.status}
            </p>
          </div>
        </div>

        {/* Comments */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label d-flex align-items-center">
              <DescriptionIcon className="me-1" fontSize="small" />
              <span>Comments</span>
            </label>

            <textarea
              className="form-control"
              value={leave.comments || "no comments found"}
              disabled
              rows={5} // You can increase height
              style={{ backgroundColor: "#f3f4f6", color: "#6B7280" }}
            />
          </div>
        </div>
       
      </div>
       <div className="w-100 d-flex align-items-center pb-4 justify-content-center">
      <button
  onClick={copyScreenshot}
  className="add_btn text-center"
  disabled={loading}
  
>
  {loading ? <BtnLoader /> : "Copy to Clipboard"}
</button>

        </div>
    </div>
  );
};
